import normalize from 'json-api-normalizer';

export default class QuestionChoice {
	static from (jsonapi) {
		let key = 'questionChoices'
		let normalizedJSONapi = normalize(jsonapi);
		if (!(Object.keys(normalizedJSONapi).includes(key))) return null;

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = QuestionChoice.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return QuestionChoice.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi, noRelationships=0) {
		if (jsonapi) {
			const { id, attributes } = jsonapi;
			return new QuestionChoice ( Object.assign({id: id}, attributes) );
		} else {
			console.log ("ERROR: Invalid Question Choice Presented")
		}
	}

	constructor ({ id, value, text, number, questionId }) {
		this.id              = id ? id : -1;
		this.value           = value; // String();
		this.text            = text;
		this.number 		 = number;
		this.question_id     = questionId ? questionId : false;
	}

	toJSONapi () {
		let attributes = Object.assign({}, this);
		delete attributes.id;

		return {data: {type: "question_choices", id: this.id, attributes: attributes}};
	}
}
